import { Component, ElementRef, HostListener, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { StorageService } from "src/app/shared/services/storage.service";

@Component({
  selector: "app-my-account",
  templateUrl: "./my-account.component.html",
  styleUrls: ["./my-account.component.scss"],
})
export class MyAccountComponent implements OnInit {
  public userName: string;
  public profileImg: "assets/images/dashboard/profile.jpg";
  loginModel :any = {};
  isDropdownOpen: boolean = false;

  constructor(public router: Router,public storageService: StorageService, private elementRef: ElementRef) {
  }

  ngOnInit() {
    this.loginModel = this.storageService.retrieve('USER_DETAILS');
  }

 toggleDropdown(event: Event) {
    event.stopPropagation();
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  @HostListener('document:click', ['$event'])
  closeDropdown(event: Event) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.isDropdownOpen = false;
    }
  }

  logoutFunc() {
    this.storageService.clear();
    this.router.navigateByUrl('account/login');
  }
}
